export default __webpack_public_path__ + "78bb26c3d4484dcd99ef3dbd08339852.png";